// Pure client-side facet controls for the primary flow: a global therapist
// filter (only when the tenant enabled picker mode) plus a time-of-day
// segmented control. Neither triggers a fetch — they narrow the already-cached
// "any"-therapist slots.

import type { WidgetChideskStaff } from "../../types";
import type { TimeOfDay } from "../../state/chidesk-availability";
import { TherapistPicker } from "./TherapistPicker";

const TOD_OPTIONS: { key: TimeOfDay; label: string }[] = [
  { key: "any", label: "Any time" },
  { key: "morning", label: "Morning" },
  { key: "afternoon", label: "Afternoon" },
  { key: "evening", label: "Evening" },
];

export function FilterBar({
  staff,
  employeePickEnabled,
  therapistFilter,
  onTherapistChange,
  therapistEnabledIds,
  tod,
  onTodChange,
}: {
  staff: WidgetChideskStaff[];
  employeePickEnabled: boolean;
  therapistFilter: string | null;
  onTherapistChange: (staffId: string | null) => void;
  /** Staff row ids that have a slot in the current anchor facet (others dim). */
  therapistEnabledIds: Set<string> | null;
  tod: TimeOfDay;
  onTodChange: (tod: TimeOfDay) => void;
}) {
  const showTherapist = employeePickEnabled && staff.length > 0;
  return (
    <div className="vt-chidesk-filterbar">
      {showTherapist && (
        <TherapistPicker
          staff={staff}
          value={therapistFilter}
          onChange={onTherapistChange}
          enabledIds={therapistEnabledIds}
        />
      )}
      <div className="vt-chidesk-tod">
        <span className="vt-chidesk-therapists-label">Time of day</span>
        <div className="vt-chidesk-tod-seg">
          {TOD_OPTIONS.map((o) => (
            <button
              key={o.key}
              type="button"
              className={`vt-chidesk-tod-btn${tod === o.key ? " vt-chidesk-tod-btn-active" : ""}`}
              onClick={() => onTodChange(o.key)}
              aria-pressed={tod === o.key}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
